import { useEffect, useState } from "react";
import { PageHeader } from "components/PageHeader/PageHeader";
import Container, { ContainerDesktop } from "components/Container";
import { useBlogArticleDetailApi } from "modules/Blog/blogApi";
import { Image } from "components/Image/Image";
import { toDDMMYYYY, toDDMMYYYYHHMM } from "lib/date";
import { useRouter } from "next/router";
import CardSticky from "components/Card/CardSticky";
import IconClose from "components/Icon/IconClose";
import { useToastStore } from "components/Toast/toastStore";
import { CardAds } from "components/Card/CardAds";
import { trackEvent } from "lib/amplitude";
import { ModalShare } from "components/Modal/ModalShare";
import { generateShareContent } from "lib/helper";
import { useIsDesktop } from "lib/device";
import { PageHeaderDesktop } from "components/PageHeader/PageHeaderDesktop";
import { IconTimer } from "components/Icon/IconTimer";
import Footer from "components/Footer";

export const BlogArticleDetail: React.FC<{ slug: string; data?: any }> = ({
  slug,
  data,
}) => {
  const [showAds, setShowAds] = useState(false);
  const [isShow, setShow] = useState(false);
  const [dataShare, setDataShare] = useState([]);
  const [contentBlog, setContentBlog] = useState([]);

  const router = useRouter();

  const showToast = useToastStore((state) => state.showToast);
  const blogArticleDetailApi = useBlogArticleDetailApi(slug);
  // const data = blogArticleDetailApi.data?.data;
  const isHideHeader = router.query.hideHeader === "false";
  const isDesktop = useIsDesktop();

  useEffect(() => {
    // blogArticleDetailApi.doFetch({ slug });

    if (!router.query.hideHeader) {
      if(router.pathname == "/blog/[blogSlug]"){
        // @ts-ignore
        router.push({
          pathname: "/blog/[blogSlug]",
          // pathname: router.pathname,
          query: {
            blogSlug: slug,
            hideHeader: "false",
          },
        });
      }
    }
  }, [router, slug]);

  const onShare = () => {
    if (typeof window !== "undefined") {
      if (window.screen.width > 481) {
        setShow(true);
      } else {
        if (navigator.canShare) {
          navigator.share({ title: data?.title, url: window.location.href });
        }
      }
    }
  };

  const insertAt = (
    array: any[],
    index: number,
    ...elementsArray: string[]
  ) => {
    return array.splice(index, 0, ...elementsArray);
  };

  useEffect(() => {
    if (data) {
      // trackEvent({
      //   event: "blog_article_s",
      //   property: {
      //     blog_title: data?.title,
      //     blog_slug: data?.slug,
      //   },
      // });

      let paraArray = data?.content
        .split("</p>")
        .flatMap((a) => a.replace("\n", "<br />"));

      insertAt(paraArray, Math.floor(paraArray.length / 2), "in-ads");
      setContentBlog(paraArray);
      setDataShare(generateShareContent(data, true));
    }
  }, [data]);

  const propsModal = {
    title: "Bagikan Melalui",
    isShow,
    onClose: () => setShow(false),
    data: dataShare,
  };

  const url = router.query.url;

  const renderContent = (elm) => {
    return (
      <div className={"flex flex-col gap-32 pt-36 w-[70%] m-auto xl-max:gap-0 xl-max:w-full xl-max:pt-8"}>
        <div className={"grid gap-24 xl-max:gap-8 xl-max:p-16"}>
          <h1 className={"text-h3 xl-max:text-h4 font-black"}>{elm?.title}</h1>

          <div className="flex justify-between items-center xl-max:flex-col xl-max:items-start xl-max:gap-20">
            <div
              className={
                "text-neutral-60 font-medium flex gap-4 items-center text-b1 xl-max:text-c1"
              }
            >
              <IconTimer size={14} />
              {toDDMMYYYYHHMM(elm?.created_at, "long", false, true)}
            </div>

            <ModalShare {...propsModal} useModal={false} />
          </div>
        </div>

        <div className={"mb-64 xl-max:p-16 xl-max:mb-16 pt-0"}>
          <div
            dangerouslySetInnerHTML={{
              __html: contentBlog
                .map((a, index) => {
                  if (a == "in-ads") {
                    {
                      /*  Ad Slot Blog Center  */
                    }
                    return `<div style="clear: both; text-align: center; margin: 10px;" key="center-of-blog" id="center-of-blog"><ins class="adsbygoogle" data-full-width-responsive="true" data-ad-format="auto" data-ad-client="ca-pub-9455978208365758" data-ad-slot="9094238882"></ins></div>`;
                  } else {
                    return a;
                  }
                })
                .join("<br>"),
            }}
            className="wrap-article"
          ></div>

          <div className={"h-[50vh] w-full m-auto mb-16 xl-max:h-[207px]"}>
            <Image
              src={elm?.image_url}
              alt={elm?.title}
              className={
                "w-full h-full rounded-2 overflow-hidden object-cover object-center my-16"
              }
            />
          </div>

          <CardAds slotId="7398013833" />
        </div>

        {/* <BlogArticleRelated title="Artikel Terkait" /> */}

        {showAds && <div className="h-30 pb-[3rem]"></div>}

        {showAds && (
          <CardSticky
            classes="flex items-center justify-center p-[1rem]"
            full={false}
          >
            <div className="w-full p-[1rem] rounded-lg flex flex-col justify-center text-center text-white bg-neutral-60">
              <div className="flex justify-flex-end mb-[-1rem]">
                <button
                  type="button"
                  className="ml-auto bg-white rounded cursor-pointer z-10"
                  onClick={() => setShowAds(!showAds)}
                >
                  <IconClose size={20} />
                </button>
              </div>
              <p className="z-0">Sticky Placeholder</p>
              <p className="z-0">328x72</p>
            </div>
          </CardSticky>
        )}
      </div>
    );
  };

  // if (isDesktop) {
  return (
    <div>
      <div className="block xl-max:hidden">
        <PageHeaderDesktop />
      </div>

      <div className="hidden xl-max:block">
        {isHideHeader && (
          <PageHeader
            withBackButton
            backTo={{
              pathname: url && url == "blog" ? "/blog" : "/",
            }}
            onShare={onShare}
          />
        )}
      </div>

      <ContainerDesktop className="flex xl-max:w-full xl-max:m-0">
        {renderContent(data)}
      </ContainerDesktop>

      <Footer />
    </div>
  );
  // } else {
  //   return (
  //     <Container className="min-h-screen">
  //       {renderContent(data)}
  //       <ModalShare {...propsModal} />
  //     </Container>
  //   );
  // }
};
